/**
 * There have been issues with some versions of Safari on some operating systems throwing issues with some parameters in the formatOptions.
 *
 * If an error is thrown, we remove some troublesome params from the formatOptions object and fallback to no formatting.
 * This allows us to degrade somewhat gracefully without breaking the dashboard for users of unaffected browsers.
 *
 * For more information, see:
 * - https://www.notion.so/matchwornshirt/Currency-bug-Failed-to-initialize-NumberFormat-d9601f388ee14bdb94ef572e245aa3c8?pvs=4
 * - https://github.com/google/site-kit-wp/issues/3255
 */
export const getBackwardsCompatibleNumberFormat = (...args) => {
    try {
        return new Intl.NumberFormat(...args);
    }
    catch (error) {
        const [locale, formatOptions] = args;
        if (!formatOptions)
            return new Intl.NumberFormat(locale);
        // Remove these keys from formatOptions irrespective of value.
        const unstableFormatOptions = ["signDisplay", "compactDisplay"];
        // Remove these key/values from formatOptions.
        const unstableFormatOptionValues = {
            currencyDisplay: "narrowSymbol",
            currencySign: "accounting",
            style: "unit",
        };
        const reducedFormatOptions = {};
        for (const [key, value] of Object.entries(formatOptions)) {
            if (unstableFormatOptions.includes(key))
                continue;
            if (key in unstableFormatOptionValues &&
                value ===
                    unstableFormatOptionValues[key]) {
                continue;
            }
            reducedFormatOptions[key] = value;
        }
        try {
            return new Intl.NumberFormat(locale, reducedFormatOptions);
        }
        catch (_a) {
            return new Intl.NumberFormat(locale);
        }
    }
};
